import { formatBoolean } from 'components/helper/helper';
import React from 'react';

interface Props {
  data: any;
}

const CourseCollegeSum = ({ data }: Props) => {
  return (
    <>
      {(data || []).map((item: any, index: number) => (
        <div key={index} className="gm-summary-conditional-section">
          <div className="gm-summary-conditional-title">
            {[item?.collegeName, item?.term, item?.academicYear].filter((i) => !!i).join(' - ')}
          </div>
          
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">Schedule System *</div>
              <div className="gm-summary-field-value">
                {item?.scheduleSystem || '-'}
              </div>
            </div>
            <div className="gm-summary-field-item">
              <div className="gm-summary-field-label">College Academic Status</div>
              <div className="gm-summary-field-value">
                {item?.academicStatus || '-'}
              </div>
            </div>
          </div>

          {(item?.collegeCourseArray ?? []).map((itemCourse: any, courseIndex: number) => (
            <div key={courseIndex} className="gm-summary-conditional-section">
              <div className="gm-summary-conditional-title">
                Course {courseIndex + 1}
              </div>
              
              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Course Information</div>
                  <div className="gm-summary-field-value">
                    {[itemCourse?.dept, itemCourse?.courseNumber, itemCourse?.courseName]
                      .filter((i) => !!i)
                      .join(' - ') || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Course Details</div>
                  <div className="gm-summary-field-value">
                    {[
                      `Course Subject: ${itemCourse?.collegeCourseSubject}`,
                      `A-G Subject: ${itemCourse?.subject}`,
                      `Honor Status: ${itemCourse?.honorStatus}`,
                    ].join(' - ') || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-field-grid">
                <div className="gm-summary-field-item">
                  <div className="gm-summary-field-label">Grade Information</div>
                  <div className="gm-summary-field-value">
                    {[
                      `Grade: ${itemCourse?.grade}`,
                      `Credits: ${itemCourse?.creditsPerHours}`,
                      `Completion Status: ${itemCourse?.completionStatus}`,
                    ].join(' - ') || '-'}
                  </div>
                </div>
              </div>

              <div className="gm-summary-checkbox-container">
                <span style={{
                  marginRight: '12px',
                  fontSize: '18px',
                  color: formatBoolean(itemCourse?.transferable) ? '#1890ff' : '#d9d9d9',
                  fontWeight: formatBoolean(itemCourse?.transferable) ? 'bold' : 'normal',
                }}>
                  {formatBoolean(itemCourse?.transferable) ? '✓' : '○'}
                </span>
                Transferable
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default CourseCollegeSum;
